<div class="sidecontent-option-container">
  <mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-chart-arc"></i>
    <span class="title">Metrics of usage</span>
  </mat-toolbar>
  <div class="scroll-container">
    <div class="header">
      <h3 class="title">Filter by</h3>
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onToggleChange($event)">
        <mat-button-toggle *ngFor="let option of options" [value]="option.value" [checked]="option.value == 'Week'">
          {{ option.name }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="application-container">
      <div class="row g-4">
        <div class="col-md-4">
          <mat-card>
            <mat-card-content>
              <div class="content">
                <h2 class="value">{{apiData?.appInstallations}}</h2>
                <p class="label">App Installations</p>
              </div>
              <i class="icon mdi mdi-tray-arrow-down"></i>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-4">
          <mat-card>
            <mat-card-content>
              <div class="content">
                <h2 class="value">{{apiData?.users}}</h2>
                <p class="label">Active users</p>
              </div>
              <i class="icon mdi mdi-account-circle-outline"></i>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-4">
          <mat-card>
            <mat-card-content>
              <div class="content">
                <h2 class="value">{{apiData?.submissions}}</h2>
                <p class="label">submissions</p>
              </div>
              <i class="icon mdi mdi-check"></i>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-12">
          <mat-card class="chart">
            <mat-card-header>
              <mat-card-title>App Installations</mat-card-title>
            </mat-card-header>
            <mat-card-content>
           <div *ngIf="installationsChart.spinner" class="spinnerCenter">
            <mat-spinner diameter="35"></mat-spinner>  
          </div>
           <vl-chart style="width: 100%;" *ngIf="installationsChart.visibility.renderChart" [chartOptions]="installationsChart.config"></vl-chart>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-6">
          <mat-card class="chart">
            <mat-card-header>
              <mat-card-title>Active Users</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div *ngIf="userChart.spinner" class="spinnerCenter">
                <mat-spinner diameter="35"></mat-spinner>  
              </div>
           <vl-chart style="width: 100%;" *ngIf="userChart.visibility.renderChart" [chartOptions]="userChart.config"></vl-chart>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-6">
          <mat-card class="chart">
            <mat-card-header>
              <mat-card-title>Submissions</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div *ngIf="submissionsChart.spinner" class="spinnerCenter">
                <mat-spinner diameter="35"></mat-spinner>  
              </div>
           <vl-chart  style="width: 100%;" *ngIf="submissionsChart.visibility.renderChart" [chartOptions]="submissionsChart.config"></vl-chart>
            </mat-card-content>
          </mat-card>
        </div>
        
      </div>
    </div>
  </div>
</div>